module.exports = __webpack_public_path__ + "media/images/pwa/safari-icon-7f29e6d9d22266e0b4a03e82017534cb.png";